import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { Element } from 'react-scroll'
import MasterData from '../../data/MasterData'
import TrainLaneData from '../../data/TrainLaneData'
import Train from './Train'
import MultipleTrain from './MultipleTrain'
import { stationNumberClass } from '../../utils/ClassHelper'

const TrainPositionTokyuParallelStationItem = (props) => {
  const { lineName, station, trains, themeName, openTrainSelectModal, intl } = props
  const locale = intl.locale
  const navigate = useNavigate()

  const lineId = () => {
    return MasterData.lineIdByLineName(lineName)
  }

  // 次の駅ID
  const nextStationIds = (direction) => {
    if (!station) return null

    if ( direction === 'up') {
      if (station.id === 67) { // 田園調布
        return [68, 118] // 自由が丘と奥沢
      }
      return [MasterData.upNextStationId(lineId(), station.id)]
    } else {
      return [station.id]
    }
  }

  // nextStationId に向かっている営業運転列車を返す
  const trainsToward = (direction, lane) => {
    const nextStationIdsData = nextStationIds(direction)
    if (!nextStationIdsData) return []

    return trains.filter(train => (
      train.line_id === lineId() &&
      nextStationIdsData.includes(train.next_station_id) && 
      train.direction === direction &&
      lane === TrainLaneData.getLane(train, station.id)
    )).sort((a, b) => {
      // positionは次駅に近い方から昇順に設定されているので、上りでは昇順、下りでは降順にソートする
      if (direction === 'up') {
        return a.position - b.position;
      } else {
        return b.position - a.position;
      }
    });
  }

  // 駅の指定された方向＆指定された lane に止まっている電車を返す
  const trainsOnStationWithLane = (direction, lane) => {
    return trainsOnStation(direction).filter(train => lane === TrainLaneData.getLane(train, station.id))
  }

  // 駅の指定された方向に止まっている電車を返す
  const trainsOnStation = (direction) => {
    if (!station) return []

    return trains.filter(train => (
      !train.next_station_id && // JR線内の駅間在線列車は、station_id(後方駅), next_station_id両方が入っているので除く
      train.station_id === station.id &&
      train.direction === direction
    ))
  }
    
  const renderTrain = (trainsData) => {
    if (trainsData.length == 0) {
      return
    } else if (trainsData.length == 1) {
      return <Train
        {...props}
        key={`train${trainsData[0].operation_number}`}
        train={trainsData[0]}
        intl={intl}
      />  
    } else {
      const sortedTrains = trainsData.slice().sort((a, b) => {
        const aOrder = (a.train_kind_id && MasterData.trainKindById(a.train_kind_id).station_detail_order) ? MasterData.trainKindById(a.train_kind_id).station_detail_order : 99
        const bOrder = (b.train_kind_id && MasterData.trainKindById(b.train_kind_id).station_detail_order) ? MasterData.trainKindById(b.train_kind_id).station_detail_order : 99
        return aOrder - bOrder
      })

      return <MultipleTrain
        {...props}
        key={`train${trainsData[0].operation_number}`}
        trains={sortedTrains}
        openTrainSelectModal={openTrainSelectModal}
        intl={intl}
        />
    }
  }

  const handleTransferClick = () => {
    navigate(`/stations/${station.id}/transfers`)
  }

  const renderLineElement = () => {
    const lineClass = station.lineClass === undefined ? '' : station.lineClass

    return <div className={`d-TrainPosition-line ${lineClass}`}></div>
  }

  const renderLineNameElement = () => {
    switch(station.kind) {
      case 'thruToJR':
        return  <span className="d-TrainPosition-lineLabel">
                  <FormattedMessage id='App.TrainPositions.thruToJR' values={{br: <br key="br" />}} />
                </span>
      case 'thruToFukutoshin':
        return  <span className="d-TrainPosition-lineLabel">
                  <FormattedMessage id='App.TrainPositions.thruToFukutoshin' values={{br: <br key="br" />}} />
                </span>
      case 'thruToNambokuMita':
        return  <span className="d-TrainPosition-lineLabel">
                  <FormattedMessage id='App.TrainPositions.thruToNambokuMita' values={{br: <br key="br" />}} />
                </span>
      default:
        return ''
    }
  }

  const renderSwitchLinkElement = () => {
    switch(station.kind) {
      case 'izuminoBranchStart':
        return <Link to="/lines/izumino/trains" className={`d-TrainPosition-lineSwitchButton d-TrainPosition-lineSwitchButton-${themeName} is_next`}>{MasterData.line(2)[`name_${locale}`]}</Link>
      case 'shinyokohamaBranchStart':
        return <Link to="/lines/for_tokyu/trains#28" className={`d-TrainPosition-lineSwitchButton d-TrainPosition-lineSwitchButton-${themeName} is_prev`}>{MasterData.line(3)[`name_${locale}`]}</Link>
      case 'shinyokohamaBranchEnd':
        return <Link to="/lines/main/trains" className={`d-TrainPosition-lineSwitchButton d-TrainPosition-lineSwitchButton-${themeName} is_next`}>{MasterData.line(1)[`name_${locale}`]}</Link>
      case 'jrBranchStart':
        return <Link to="/lines/for_jre/trains" className={`d-TrainPosition-lineSwitchButton d-TrainPosition-lineSwitchButton-${themeName} is_prev`}>{MasterData.line(4)[`name_${locale}`]}</Link>
      case 'jrBranchEnd':
        return <Link to="/lines/for_tokyu/trains" className={`d-TrainPosition-lineSwitchButton d-TrainPosition-lineSwitchButton-${themeName} is_next`}>{MasterData.line(3)[`name_${locale}`]}</Link>
    }
  }

  const renderTransferLinkElement = () => {
    if (station.transfers && station.transfers.length > 0) {
      return <a onClick={handleTransferClick} className={`d-TrainPosition-transferSwitchButton d-TrainPosition-transferSwitchButton theme_${themeName} is_next is_${locale}`}></a>
    }
  }

  const renderAdditionalElement = () => {
    switch(station.kind) {
      case 'izuminoBranchStart':
        return <div className={`d-TrainPosition-line is_bottom is_right`}></div>
      case 'shinyokohamaBranchStart':
        return <div className={`d-TrainPosition-line is_bottom is_left`}></div>
      case 'jrBranchStart':
        return <div className={`d-TrainPosition-line is_bottom is_left is_center`}></div>
    }
  }

  const renderStationName = () => {
    return(
      <div className={`d-TrainPosition-stationInfo ${['shinyokohamaBranchEnd', 'jrBranchEnd'].includes(station.kind) ? 'is-hidden' : ''}`}>
        <Link to={`/stations/${station.id}`} className={`d-TrainPosition-stationInfoLink ${station.linkDisabled ? 'is-disabled' : ''}`}>
          <div className='d-TrainPosition-stationNumbers'>
            {station.eki_number.split(',').map(ekiNumber => (
              <div className={`d-TrainPosition-stationNumber ${stationNumberClass(ekiNumber, themeName)}`} key={`stationNumber${ekiNumber}`}></div>)
            )}
          </div>
          {renderStationNameMain()}
          {renderStationNameEn()}
        </Link>
      </div>
    )
  }

  const renderStationNameMain = () => {
    // 羽沢駅だけ改行を入れる
    if (station.id === 28) {
      return(
        <p className={`d-TrainPosition-stationName01 d-TrainPosition-stationName01--hazawaYokohamaKokudai is_${locale}`}>{station[`name_${locale}`]}</p>
      )
    } else {
      return(
        <p className={`d-TrainPosition-stationName01 is_${locale}`}>{station[`name_${locale}`]}</p>
      )
    }
  }

  const renderStationNameEn = () => {
    // 羽沢駅だけ改行を入れる
    if (station.id === 28) {
      return(
        <p className={`d-TrainPosition-stationName02 is_${locale}`}>Hazawa<br/> yokohama-kokudai</p>
      )
    } else {
      return(
        <p className={`d-TrainPosition-stationName02 is_${locale}`}>{station.name_en}</p>
      )
    }
  }

  const renderLineInfo = () => {
    if (!station.lane_numbers) { return }
    if (station.lineInfoHidden) { return }

    return(
      <div className="d-TrainPosition-laneNumbers">
        <p className="d-TrainPosition-laneLabel"><FormattedMessage id='App.TrainPositions.track' /></p>
        <p>{station.lane_numbers}</p>
      </div>
    )
  }

  const renderRunningTrainPositionBlockRow = (direction) => {
    return(
      <div className="d-TrainPosition-blockRow">
        <div className="d-TrainPosition-blockItem">
          {renderTrain(trainsToward(direction, direction === 'up' ? 'outer' : 'inner'))}
        </div>

        <div className="d-TrainPosition-blockItem">
          {renderTrain(trainsToward(direction, direction === 'up' ? 'inner' : 'outer'))}
        </div>
      </div>
    )
  }

  const renderStationTrainPositionBlockRow = (direction) => {
    return(
      <div className="d-TrainPosition-blockRow">
        <div className="d-TrainPosition-blockItem">
          {renderTrain(trainsOnStationWithLane(direction, direction === 'up' ? 'outer' : 'inner'))}
        </div>

        <div className="d-TrainPosition-blockItem">
          {renderTrain(trainsOnStationWithLane(direction, direction === 'up' ? 'inner' : 'outer'))}
        </div>
      </div>
    )
  }

  const itemClass = station.itemClass === undefined ? '' : station.itemClass

  return (
    <li className={`d-TrainPosition-stationItem ${itemClass}`} >
      <Element id={`station${station.id}`} />
      {renderStationName()}
      {renderLineElement()}
      {renderLineNameElement()}
      {renderAdditionalElement()}
      {renderLineInfo()}

      <div className="d-TrainPosition-block">
        {/* 駅間に停車中 & 上り */}
        {renderRunningTrainPositionBlockRow('up')}

        {/* 駅間に停車中 & くだり */}
        {renderRunningTrainPositionBlockRow('down')}

      </div>
      {renderSwitchLinkElement()}
      {renderTransferLinkElement()}

      <div className="d-TrainPosition-block is_on_station">
        {/* 駅の上に停車中 & 上り */}
        {renderStationTrainPositionBlockRow('up')}

        {/* 駅の上に停車中 & くだり */}
        {renderStationTrainPositionBlockRow('down')}
      </div>
    </li>
  )
}

TrainPositionTokyuParallelStationItem.propTypes = {
  lineName: PropTypes.string.isRequired,
  station: PropTypes.object,
  trains: PropTypes.array.isRequired,
  themeName: PropTypes.string.isRequired,
  openTrainSelectModal: PropTypes.func,
  intl: PropTypes.object.isRequired,
}

export default injectIntl(TrainPositionTokyuParallelStationItem)
